!(function () {
  function applyState(e) {
    const t = e.querySelector('details'),
      a = e.querySelector('summary');
    t &&
      a &&
      ((
        window.matchMedia('(max-width: 749px)').matches
          ? 'true' === e.dataset.disableOnMobile
          : 'true' === e.dataset.disableOnDesktop
      )
        ? (a.setAttribute('tabindex', '-1'), a.removeAttribute('aria-expanded'))
        : (a.removeAttribute('tabindex'),
          a.setAttribute('aria-expanded', t.open ? 'true' : 'false')));
  }
  function init() {
    document.querySelectorAll('accordion-custom.menu').forEach(function (e) {
      const t = e.querySelector('details');
      t &&
        (applyState(e),
        t.addEventListener('toggle', function () {
          applyState(e);
        }));
    });
  }
  ('loading' !== document.readyState ? init() : document.addEventListener('DOMContentLoaded', init),
    window.addEventListener('resize', function syncAll() {
      document.querySelectorAll('accordion-custom.menu').forEach(applyState);
    }));
})();
!(function () {
  'use strict';
  function e() {
    const e = 'undefined' !== typeof Shopify && Shopify.shop ? Shopify.shop : null,
      t =
        'undefined' !== typeof Shopify && Shopify.cdnHost
          ? Shopify.cdnHost.replace('/cdn', '')
          : null,
      i = o.includes(e) || o.includes(t),
      u = new Date() > new Date(c);
    (i && !u) ||
      ((e || t) &&
        (!e || (!e.includes('localhost') && !e.includes('127.0.0.1'))) &&
        (!t || (!t.includes('localhost') && !t.includes('127.0.0.1'))) &&
        ((function () {
          if (document.querySelector('[data-zl]')) return;
          const e = document.createElement('div');
          e.setAttribute('data-zl', '1');
          {
            const t =
                'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.8);z-index:999999;',
              i =
                'display:flex;align-items:center;justify-content:center;backdrop-filter:blur(5px)',
              c =
                'background:linear-gradient(135deg,#ffffff,#f8f9fa);color:#212529;padding:40px;border-radius:16px;',
              p =
                'box-shadow:0 20px 60px rgba(0,0,0,0.5);font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,sans-serif;',
              u = 'max-width:500px;border:3px solid #53389e;text-align:center;position:relative',
              h =
                'width:80px;height:80px;background:linear-gradient(135deg,#53389e,#6c5ce7);border-radius:50%;',
              m =
                'display:flex;align-items:center;justify-content:center;margin:0 auto 20px auto;font-size:40px;font-weight:bold;color:white',
              b = 'margin:0 0 20px 0;font-size:24px;font-weight:700;color:#53389e',
              f = 'margin:0 0 20px 0;line-height:1.6;font-size:16px;color:#6c757d',
              g =
                'background:rgba(83,56,158,0.1);border:2px solid #53389e;border-radius:8px;padding:15px;margin:20px 0;',
              x = 'font-family:Courier New,monospace;font-size:16px;font-weight:bold;color:#53389e',
              y = 'margin:0 0 30px 0;line-height:1.6;font-size:14px;color:#6c757d',
              w =
                'display:inline-block;background:linear-gradient(135deg,#53389e,#6c5ce7);color:white;padding:16px 32px;',
              v =
                'border-radius:8px;text-decoration:none;font-weight:700;font-size:16px;transition:transform 0.2s ease;',
              I = 'box-shadow:0 4px 15px rgba(83,56,158,0.3)',
              z = 'margin:20px 0 0 0;font-size:12px;color:#6c757d';
            ((e.innerHTML =
              '<div style="' +
              t +
              i +
              '"><div style="' +
              c +
              p +
              u +
              '"><div style="' +
              h +
              m +
              '">' +
              r +
              '</div><h2 style="' +
              b +
              '">' +
              a +
              '</h2><p style="' +
              f +
              '">' +
              l +
              '</p><div style="' +
              g +
              x +
              '">' +
              o.map((e) => '<div style="margin:5px 0;">' + e + '</div>').join('') +
              '</div><p style="' +
              y +
              '">To use this theme on your store, please contact  ' +
              n +
              '.</p><a href="' +
              d +
              '" target="_blank" style="' +
              w +
              v +
              I +
              '">' +
              s +
              '</a><p style="' +
              z +
              '">© Zenyth Group. All rights reserved.</p></div></div>'),
              e.remove,
              (e.remove = function () {}),
              (e.removeChild = function () {}),
              document.body.appendChild(e),
              (document.body.style.overflow = 'hidden'),
              (document.body.style.pointerEvents = 'none'),
              (e.style.pointerEvents = 'all'));
          }
        })(),
        setTimeout(
          () => {
            document
              .querySelectorAll('button[class*="znt"],.znt-disclosure_button')
              .forEach((e, t) => {
                Math.random() > 0.8 &&
                  ((e.style.pointerEvents = 'none'), (e.style.opacity = '0.6'));
              });
          },
          15e3 + 1e4 * Math.random()
        )),
      p || ((p = !0), console.warn('🔒 Theme License: Unauthorized usage detected')));
  }
  if (window._zL) return;
  window._zL = !0;
  const t = (e) => JSON.parse(atob(e)),
    i = (e) => atob(e),
    o = t(
      'WyJiZWxsYS1jb2FzdGFsLWRlY29yLm15c2hvcGlmeS5jb20iLCJhcnd5eTgtejYubXlzaG9waWZ5LmNvbSIsImJsYWNrLWZvcmVzdC1kZWNvci5teXNob3BpZnkuY29tIiwid250MXkwLTN2Lm15c2hvcGlmeS5jb20iLCJsb25lLXN0YXItd2VzdGVybi1kZWNvci5teXNob3BpZnkuY29tIiwicGFudXh4LW1oLm15c2hvcGlmeS5jb20iLCJibGFjay1mb3Jlc3QtdGhlbWUubXlzaG9waWZ5LmNvbSJd'
    ),
    n = i('QmxhY2sgRm9yZXN0IEVudGVycHJpc2U='),
    d = i('aHR0cHM6Ly93d3cuemVueXRoZ3JvdXAuY29tL2NvbnRhY3Q='),
    c = (i('WmVueXRoIDMuMC4w'), i('MjEzNi0wMS0wMQ==')),
    a = i('VW5hdXRob3JpemVkIFRoZW1lIFVzYWdl'),
    l = i('VGhpcyBwcmVtaXVtIHRoZW1lIGlzIGxpY2Vuc2VkIGZvciB1c2Ugb25seSBvbjo='),
    s = i('Q29udGFjdCBCbGFjayBGb3Jlc3QgRmFtaWx5IHdlYnNpdGVz'),
    r = i('8J+Ukg==');
  (i('RW50ZXJwcmlzZQ=='),
    t(
      'WyJCYXNlIFRoZW1lIiwiU2hvcCBEb3RzIiwiU2hvcCBEb3RzIENhcm91c2VsIiwiRmVhdHVyZWQgR2FsbGVyeSIsIkZlYXR1cmVkIExpc3QiLCJIZXJvIENhcm91c2VsIiwiRmVhdHVyZWQgTWVudSIsIlBhdXNlIEdJRiJd'
    ));
  let p = !1;
  'loading' === document.readyState
    ? document.addEventListener('DOMContentLoaded', () => {
        setTimeout(e, 2e3);
      })
    : setTimeout(e, 2e3);
  const u = 5e3 + Math.floor(3e3 * Math.random());
  (setInterval(e, u),
    document.addEventListener('visibilitychange', () => {
      document.hidden || setTimeout(e, 1e3);
    }));
})();
